export default __webpack_public_path__ + "static/plug-power-48dfb1a0e5ae68c872a070e30b8c3de7.png";